import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LoadingOverlay from './LoadingOverlay';

const ProtectedRoute = () => {
  const { isAuthenticated, isLoading, isAdmin, userProfile } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <LoadingOverlay />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // Verificar rutas administrativas: solo permitidas si isAdmin es true
  if (location.pathname.startsWith('/admin') && !isAdmin) {
    console.warn('Access denied to admin route. User is not admin:', { userProfile, path: location.pathname });
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
